<template>
    <div>
        <Breadcrumbs main="Settings" title="Settings" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Admin details</h5>
							</div><br>
							
							<form @submit.prevent="updateSettings('admin')" enctype="multipart/form-data">
								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Name</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.name" v-bind:class="{ 'is-invalid': Boolean(errors.user_name) }"/>
											<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Username</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.user_name" v-bind:class="{ 'is-invalid': Boolean(errors.user_name) }"/>
											<div v-for="(val, index) in errors.user_name" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Email</label>
											<input class="form-control" type="text" placeholder="" v-model="admin.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>
											<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Phone</label>
											<input class="form-control" placeholder="" v-model="admin.mobile" v-mobile-limit v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }" maxlength="10" minlength="10" />
											<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-4">
										<div class="mb-3">
											<label class="control-label">Admin Image</label>
											<input ref="fileinput" type="file" @change="setFile($event)" accept="image/*" class="form-control image-class"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
											
											<img v-if="preview_image" class="profile-image mt-2" :src="preview_image"  height="80" width="80"/>
											<img v-else-if="admin.profile_img" :src="$image_url + admin.profile_img" class="profile-image mt-2" alt="" height="80" width="80" />
											
											<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>

									<div class="col-sm-2"></div>
									<div class="col-sm-2 float-end" style="margin-top: 30px;">
										<button type="submit" class="btn btn-primary float-end" :disabled="submitting">
											<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
											{{ submitting ? "Saving..." : "Update" }}
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					<div class="card">
						<div class="card-body">
							<div class="row">
								<h5>Change Password</h5>
							</div><br>
							
							<form @submit.prevent="updateSettings('password')">
								<div class="row">
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Password</label>
											<input class="form-control" type="password" placeholder="" v-model="password" v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>
											<div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									<div class="col-sm-5">
										<div class="mb-3">
											<label class="control-label">Confirm Password</label>														
											<input class="form-control" type="Password" placeholder="" v-model="confirm_password" v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>
											<div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
												<p class="mb-0">{{ val }}</p>
											</div>
										</div>
									</div>
									
									<div class="col-sm-2" style="margin-top: 33px;">
										<button type="submit" class="btn btn-primary float-end" :disabled="submitting">
											<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
											{{ submitting ? "Saving..." : "Update" }}
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>

					
				</div>
			</div>
		</div>


		
	</div>
</template>

<script>
	export default {
		name: "SettingsPage",
		data() {
			return {
				admin:[],
				password: "",
				confirm_password: "",
				auto_approval: null,
				token: "",
				submitting: false,
				errors: {},

				image: "",
				preview_image: "",
			};
		},

		created() {
			this.fetchSettings();
		},

		methods: {
			
			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

			fetchSettings(page_url = null) {
				this.getToken();
				let url = "/staffs/settings";
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.admin = responseData.admin;
						
					})
					.catch((err) => console.log(err));
			},

			setFile(e) {
				this.image = e.target.files[0];
				this.preview_image = URL.createObjectURL(e.target.files[0]);
			},


			updateSettings(param) {
				if (this.submitting) return;
				this.submitting = true;
			 	this.getToken();
			 	let formData = new FormData();
			 	let url = "";
			 	if (param == "admin") {
			 		formData.append("user_name", this.admin.user_name);
					formData.append("name", this.admin.name);
					formData.append("mobile", this.admin.mobile);
					formData.append("image", this.image);
					formData.append("email", this.admin.email);

			 		url = "/staffs/updateAdmin";
			 	} else if (param == "password") {
			 		formData.append("password", this.password);
			 		formData.append("password_confirmation", this.confirm_password);

			 		url = "/staffs/changePassword";
			 	} 
			 	const config = {
			 		headers: {
			 			Authorization: "Bearer " + this.token,
			 		},
			 	};

			 	this.$axios
			 		.post(url, formData, config)
			 		.then((response) => {
			 			if (response.data.status) {
			 				this.$swal("", response.data.message, "success");
			 			} else {
			 				this.$swal("", response.data.message, "error");
			 			}
			 			this.fetchSettings();
			 			this.clearForm();
			 			if (param == "password") {
			 				this.password = "";
			 				this.confirm_password = "";
			 			}
			 		})
			 		.catch((error) => {
			 			if (error.response) {
			 				if (error.response.data.message) {
			 					this.errors = error.response.data.message;
			 					this.$swal("", error.response.data.message, "error");
			 				} else {
			 					this.$swal("", "Something went wrong", "error");
			 				}
			 			} else {
			 				this.$swal("", "Something went wrong", "error");
			 			}
			 		})
			 		.finally(() => {
			 			this.submitting = false;
			 		});
			 },
			 clearForm() {
			 	this.errors = {};
				this.image = "";
				this.preview_image = "";
			 },
		},
	};
</script>